import type { Locale } from "@ghezaa/ui";
import { useAuthUser, useFollowLanguage, useSetLanguage, useSignOut } from "../session";

/**
 * What every frame needs of the session (AppShell for the people who work in an app, RequesterShell for the people it
 * serves): signing out, choosing a language that is saved to the person (in Core, through this app), and whether the
 * page is still reloading into the language they chose elsewhere.
 */
export function useShellSession(signOutTo?: string) {
  const signOut = useSignOut(signOutTo);
  const me = useAuthUser();
  const setLanguage = useSetLanguage();
  const reloading = useFollowLanguage(me.data);
  return { signOut, chooseLanguage: (language: Locale) => setLanguage.mutateAsync(language), reloading };
}
